export interface Purchase {
  name: string
  city: string
  country: string
}

export const purchases: Purchase[] = [
  { name: 'James W.', city: 'Manchester', country: 'United Kingdom' },
  { name: 'Ryan M.', city: 'Calgary', country: 'Canada' },
  { name: 'Daniel K.', city: 'Houston', country: 'United States' },
  { name: 'Brett H.', city: 'Brisbane', country: 'Australia' },
  { name: 'Craig T.', city: 'Sheffield', country: 'United Kingdom' },
  { name: 'Marcus L.', city: 'Pittsburgh', country: 'United States' },
  { name: 'Shane P.', city: 'Perth', country: 'Australia' },
  { name: 'Kevin B.', city: 'Hamilton', country: 'Canada' },
  { name: 'Paul R.', city: 'Birmingham', country: 'United Kingdom' },
  { name: 'Travis D.', city: 'Phoenix', country: 'United States' },
  { name: 'Nathan S.', city: 'Adelaide', country: 'Australia' },
  { name: 'Doug A.', city: 'Edmonton', country: 'Canada' },
]
